import { Typography } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import {
  createStyles,
  Theme,
  WithStyles,
  withStyles
} from '@material-ui/core/styles';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import * as React from 'react';
const styles = (theme: Theme) =>
  createStyles({
    root: {
      textTransform: 'uppercase',
      marginBottom: '1rem'
    },
    heading: {
      textTransform: 'uppercase'
    },
    margin: {
      marginRight: '2rem',
      width: '25rem'
    },
    headerWrap: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '1rem'
    }
  });

interface IMainHeadingOwnProps {
  mainHeading: string;
  onClick: () => void;
}
type IMainHeadingProps = IMainHeadingOwnProps & WithStyles<typeof styles>;

function MainHeadingVariantTwo(props: IMainHeadingProps) {
  const { classes, onClick } = props;
  return (
    <div className={classes.headerWrap}>
      <IconButton aria-label="back" onClick={onClick}>
        <KeyboardArrowLeftIcon />
      </IconButton>
      <Typography variant={'h6'} className={classes.heading}>
        {props.mainHeading}
      </Typography>
    </div>
  );
}

export default withStyles(styles)(MainHeadingVariantTwo);
